const BROADER_METRO_RE = /^Broader (.+) Metro$/;
const STATE_RE = /^(AL|AK|AZ|AR|CA|CO|CT|DC|DE|FL|GA|HI|IA|ID|IL|IN|KS|KY|LA|MA|MD|ME|MI|MN|MO|MS|MT|NC|ND|NE|NH|NJ|NM|NV|NY|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VA|VT|WA|WI|WV|WY)$/i;

export function isBroaderMetroNeighborhood(neighborhood) {
  return typeof neighborhood === 'string' && BROADER_METRO_RE.test(neighborhood.trim());
}

export function getBroaderMetroLabel(metroOrName) {
  const name = typeof metroOrName === 'object'
    ? (metroOrName?.shortName || metroOrName?.name)
    : metroOrName;
  return `Broader ${name || 'City'} Metro`;
}

export function getBroaderMetroCoreName(neighborhood) {
  const match = typeof neighborhood === 'string' ? neighborhood.trim().match(BROADER_METRO_RE) : null;
  return match?.[1] || null;
}

export function municipalityFromNominatim(address = {}) {
  return (
    address.city
    || address.town
    || address.village
    || address.hamlet
    || address.municipality
    || ''
  ).trim();
}

export function parseTownFromAddress(address) {
  if (!address || typeof address !== 'string') return '';
  const parts = address.split(',').map((part) => part.trim()).filter(Boolean);
  if (parts.length < 2) return '';

  for (let i = parts.length - 1; i >= 1; i -= 1) {
    const part = parts[i].replace(/\d{5}(-\d{4})?/, '').trim();
    if (STATE_RE.test(part) || /^[A-Z]{2}$/i.test(part.split(' ')[0] || '')) {
      const town = parts[i - 1].replace(/\d{5}(-\d{4})?/, '').trim();
      if (town && !/^\d/.test(town)) return town;
    }
  }

  return '';
}

export function getBarLocationLabel(bar) {
  const neighborhood = bar?.neighborhood || '';
  if (!isBroaderMetroNeighborhood(neighborhood)) {
    return neighborhood;
  }

  const coreName = getBroaderMetroCoreName(neighborhood);
  const city = (bar?.city || '').trim();
  if (city && (!coreName || city.toLowerCase() !== coreName.toLowerCase())) {
    return city;
  }

  const fromAddress = parseTownFromAddress(bar?.address);
  if (fromAddress && (!coreName || fromAddress.toLowerCase() !== coreName.toLowerCase())) {
    return fromAddress;
  }

  return neighborhood;
}

export async function reverseGeocodeTown(lat, lng) {
  if (lat == null || lng == null || Number.isNaN(Number(lat)) || Number.isNaN(Number(lng))) {
    return '';
  }

  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lng)}&zoom=10&addressdetails=1`,
      { headers: { 'User-Agent': 'Tilted-App/1.0 (https://gettilted.app)' } }
    );
    if (!response.ok) return '';
    const data = await response.json();
    return municipalityFromNominatim(data?.address);
  } catch {
    return '';
  }
}
